import React from 'react';

export const EyeIcon = (
  <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
    <path
      d="M8 3C4.5 3 1.5 8 1.5 8S4.5 13 8 13s6.5-5 6.5-5S11.5 3 8 3zm0 8a3 3 0 110-6 3 3 0 010 6zm0-5a2 2 0 100 4 2 2 0 000-4z"
      fill="currentColor"
    />
  </svg>
);

export const LockIcon = (
  <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
    <path
      d="M8 1.5C5.52 1.5 3.5 3.37 3.5 5.67v.33H2.5A1 1 0 001.5 7v7a1 1 0 001 1h11a1 1 0 001-1V7a1 1 0 00-1-1h-1v-.33C12.5 3.37 10.48 1.5 8 1.5zm0 1.5c1.83 0 3 1.25 3 2.67V6H5v-.33C5 4.25 6.17 3 8 3zm0 8a1 1 0 110-2 1 1 0 010 2z"
      fill="currentColor"
    />
  </svg>
);

export const InfoIcon = (
  <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="7" stroke="#3b82f6" strokeWidth="1" />
    <rect x="7.25" y="6.5" width="1.5" height="5" rx="0.75" fill="#3b82f6" />
    <circle cx="8" cy="4.5" r="0.75" fill="#3b82f6" />
  </svg>
);

export const WarnIcon = (
  <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
    <path d="M8 1L.5 14.5h15L8 1z" stroke="#92650a" strokeWidth="1" strokeLinejoin="round" />
    <rect x="7.25" y="6.5" width="1.5" height="4" rx="0.75" fill="#92650a" />
    <circle cx="8" cy="12" r="0.75" fill="#92650a" />
  </svg>
);

export const MailIcon = (
  <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
    <rect x="1" y="3" width="14" height="10" rx="1.5" stroke="currentColor" strokeWidth="1" />
    <path d="M1.5 3.5l6.5 5 6.5-5" stroke="currentColor" strokeWidth="1" />
  </svg>
);

export const GoogleG = (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
    <path d="M15.5 8.18c0-.57-.05-1.12-.14-1.64H8v3.1h4.2a3.6 3.6 0 01-1.57 2.36v1.96h2.54C14.66 12.56 15.5 10.53 15.5 8.18z" fill="#4285F4" />
    <path d="M8 16c2.16 0 3.97-.72 5.3-1.94l-2.55-1.96c-.71.48-1.62.76-2.75.76-2.12 0-3.91-1.43-4.55-3.35H.82v2.02A8 8 0 008 16z" fill="#34A853" />
    <path d="M3.45 9.51A4.8 4.8 0 013.2 8c0-.53.09-1.04.25-1.51V4.47H.82A8 8 0 000 8c0 1.29.31 2.51.82 3.6l2.63-2.09z" fill="#FBBC04" />
    <path d="M8 3.17c1.19 0 2.26.41 3.1 1.22l2.32-2.32A8 8 0 00.82 4.47l2.63 2.02C4.09 4.6 5.88 3.17 8 3.17z" fill="#EA4335" />
  </svg>
);
